import React from "react";
import styles from "@src/components/helpers.module.scss";
import useSvgFillColor from "@src/hooks/useSvgFillColor";

export const TimeIcon: React.FC = () => {
	const fillColor = useSvgFillColor();

	return (
		<div className={styles.iconContainer}>
			<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
				<path
					d="M8.49998 14.6668C12.1819 14.6668 15.1666 11.6821 15.1666 8.00016C15.1666 4.31826 12.1819 1.3335 8.49998 1.3335C4.81808 1.3335 1.83331 4.31826 1.83331 8.00016C1.83331 11.6821 4.81808 14.6668 8.49998 14.6668Z"
					stroke={fillColor}
					strokeWidth="0.666667"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.5 4V8L11.1667 9.33333"
					stroke={fillColor}
					strokeWidth="0.666667"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</div>
	);
};
